<div class="invalid-feedback" *ngIf="!usingCheckBox">
  {{ getError() + '.' }}
</div>
<div class="invalid-feedback" *ngIf="usingCheckBox">
  {{ fieldName }}
</div>
